export const checkIfStringContainsNumber = (string: string): boolean => {
  return /^[0-9]+\.?[0-9]+$/.test(string);
};
